// extracted by mini-css-extract-plugin
module.exports = {"label":"ItemsSearch_label__2mcQi","input":"ItemsSearch_input__UXJD6","inputWrapper":"ItemsSearch_inputWrapper__YT8qa"};